import { Input as PureInput } from 'src/v2/components/Form/Input';
import { InputProps } from 'src/v2/components/Form/types';
import { withReduxForm } from './withReduxForm';

export const Input = withReduxForm<InputProps>(PureInput);
